import {useListView} from '../../core/ListViewProvider'
import {EmbeddignsListToolbar} from './EmbeddignsListToolbar'
import {EmbeddignsListGrouping} from './EmbeddignsListGrouping'
import {EmbeddingsListSearchComponent} from './EmbeddingsListSearchComponent'

const EmbeddingsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <EmbeddingsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <EmbeddignsListGrouping /> : <EmbeddignsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {EmbeddingsListHeader}
